import { render, staticRenderFns } from "./SupplierType.vue?vue&type=template&id=3a34b9f2&scoped=true&"
import script from "./SupplierType.vue?vue&type=script&lang=js&"
export * from "./SupplierType.vue?vue&type=script&lang=js&"
import style0 from "./SupplierType.vue?vue&type=style&index=0&id=3a34b9f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a34b9f2",
  null
  
)

export default component.exports